import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    SUPABASE_SERVICE_ROLE_KEY: z.string().optional(),
    SUPABASE_MIDDLEWARE_SERVICE_ROLE_KEY: z.string().optional(),
    SUPABASE_ACCESS_TOKEN: z.string().optional(),
    SUPABASE_ORG_ID: z.string().optional(),
    RESEND_API: z.string().optional(),
    TENANT_EXPIRY_WEBHOOK_SECRET: z.string().optional(),
    // Plain string, not .url() — an empty AUTH_URL= in .env.local must pass
    // validation so the `env.AUTH_URL || 'https://auth.zensalon.com'` fallback
    // at each call site can kick in, instead of crashing env parsing.
    AUTH_URL: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_SUPABASE_URL: z.string().url().optional(),
    NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string().optional(),
    NEXT_PUBLIC_SUPABASE_MIDDLEWARE_URL: z.string().url(),
    NEXT_PUBLIC_SUPABASE_MIDDLEWARE_ANON_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),
    NEXT_PUBLIC_SENTRY_DSN: z.string().optional(),
    NEXT_PUBLIC_RELEASE_VERSION: z.string().optional(),
  },
  runtimeEnv: {
    SUPABASE_SERVICE_ROLE_KEY: process.env.SUPABASE_SERVICE_ROLE_KEY,
    SUPABASE_MIDDLEWARE_SERVICE_ROLE_KEY:
      process.env.SUPABASE_MIDDLEWARE_SERVICE_ROLE_KEY,
    SUPABASE_ACCESS_TOKEN: process.env.SUPABASE_ACCESS_TOKEN,
    SUPABASE_ORG_ID: process.env.SUPABASE_ORG_ID,
    RESEND_API: process.env.RESEND_API,
    TENANT_EXPIRY_WEBHOOK_SECRET: process.env.TENANT_EXPIRY_WEBHOOK_SECRET,
    AUTH_URL: process.env.AUTH_URL,
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    NEXT_PUBLIC_SUPABASE_MIDDLEWARE_URL:
      process.env.NEXT_PUBLIC_SUPABASE_MIDDLEWARE_URL,
    NEXT_PUBLIC_SUPABASE_MIDDLEWARE_ANON_KEY:
      process.env.NEXT_PUBLIC_SUPABASE_MIDDLEWARE_ANON_KEY,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_RELEASE_VERSION: process.env.NEXT_PUBLIC_RELEASE_VERSION,
  },
});
